/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Table } from 'antd';
import CustomPagination from 'components/CustomPagination/CustomPagination';

const TableWrapper = styled.div`
  box-shadow: 2px 1px 4px 4px #00000010;
  border-radius: 10px;
  width: 100%;

  .ant-table-wrapper {
    background: '#ffffff36';
    position: 'relative';
    z-index: 2;
  }

  .ant-table-tbody {
    background: transparent;
  }

  .ant-table-wrapper .ant-table-thead > tr > th {
    border-bottom: 0px !important;
    background: ${(props) => (props.thBgColor ? props.thBgColor : ' #ffffff')};
  }

  .ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover {
    background-color: #f5f2fc;
  }

  .ant-table-wrapper td.ant-table-column-sort,
  .ant-table-wrapper .ant-table-thead th.ant-table-column-sort {
    background-color: #f5f2fc;
  }

  .ant-table-row:hover {
    background-color: var(--color-fill-alter) !important;
    box-shadow: 0px 3px 6px var(--color-fill-alter);
    padding: 10px;
  }

  .ant-table-cell-row-hover {
    cursor: pointer;
  }

  .ant-table-wrapper
    .ant-table:not(.ant-table-bordered)
    .ant-table-tbody
    > tr
    > td.ant-table-cell-row-hover:first-child,
  .ant-table-wrapper
    .ant-table:not(.ant-table-bordered)
    .ant-table-tbody
    > tr
    > td.ant-table-cell-row-hover:last-child {
    border-start-start-radius: 0px;
    border-end-start-radius: 0px;
  }

  .ant-table-wrapper
    .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not(
      [colspan]
    )::before {
    content: none;
  }
  .ant-table-wrapper .ant-table-tbody > tr > td {
    ${(props) =>
      props.hasBorderTop ? 'border-top: 0.6px solid #e8e8e9 !important;' : 'border-top: none;'}
  }
  .ant-table-wrapper .ant-table-pagination.ant-pagination {
    margin: 16px;
  }

  .ant-table-wrapper .ant-table.ant-table-middle .ant-table-thead > tr > th,
  .ant-table-wrapper .ant-table.ant-table-middle .ant-table-tbody > tr > td {
    padding: 12px 20px;
  }

  .ant-table-pagination.ant-pagination {
    background: #ffffff;
    margin: 0px !important;
    padding: 16px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;

function EbzTable({ fetchTransactions, newPagination, ...props }) {
  const { nextCursor, prevCursor, pageNumber } = newPagination ?? {
    nextCursor: null,
    prevCursor: null,
    pageNumber: 1
  };
  return (
    <TableWrapper hasBorderTop={props.hasBorderTop} thBgColor={props.thBgColor}>
      <Table {...props} />
      {/* isPagination -- props is passed when we donot want pagination of antdesign and also custom pagination */}
      {props?.isPagination && !props?.pagination && (
        <CustomPagination
          onChangeHandle={fetchTransactions}
          currentPageNumber={pageNumber}
          prevCursor={prevCursor}
          nextCursor={nextCursor}
        />
      )}
    </TableWrapper>
  );
}

EbzTable.propTypes = {
  fetchTransactions: PropTypes.func,
  newPagination: PropTypes.shape({
    nextCursor: PropTypes.string,
    prevCursor: PropTypes.string,
    pageNumber: PropTypes.number
  }),
  hasBorderTop: PropTypes.bool,
  pagination: PropTypes.bool,
  isPagination: PropTypes.bool,
  thBgColor: PropTypes.string
};

EbzTable.defaultProps = {
  fetchTransactions: () => {},
  newPagination: {
    nextCursor: null,
    prevCursor: null,
    pageNumber: 1
  },
  hasBorderTop: false,
  thBgColor: '#ffffff',
  pagination: false,
  isPagination: true
};

export default EbzTable;
